<script setup lang="ts">
/* Stores */
import { useCityStore } from '@/store/city/city'

/* Types */
import { Modification } from '@/types/api/api-v3/product'

type Props = {
  currentModification: Modification
}

const props = defineProps<Props>()

const { currencySymbol } = useCityStore()

const discountTag = computed(() => {
  if (props.currentModification.discount) {
    return props.currentModification.price - props.currentModification.subprice
  }

  return 0
})
</script>

<template>
  <div class="product-card-tags">
    <div
      v-if="discountTag"
      class="product-card-tags__item product-card-tags__item--discount"
    >
      {{ discountTag }}&nbsp;{{ currencySymbol }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.product-card-tags {
  display: flex;
  gap: 4px;
  min-height: 21px;
  padding: 8px;

  @include media('>=desktop-mini') {
    min-height: 40px;
    padding: 16px 16px 8px;
  }

  &__item {
    padding: 4px 8px;
    font-size: 8px;
    font-weight: 700;
    line-height: 10px;
    text-align: center;
    border-radius: 100px;

    &--discount {
      color: var(--ui-text-primary);
      background-color: var(--ui-yellow);
    }

    @include media('>=desktop-mini') {
      font-size: 12px;
      font-weight: 800;
      line-height: 16px;
    }
  }
}
</style>
